export default __webpack_public_path__ + "images/3f9ef3d7d3c2bd54a3e1b0705d980545.svg";